//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { axiosGet } from '../../../../../axios/axios.js'
import { formatTrueFalse } from '../../../../../components/helpers.js'

export default {
  props: {
    brigade: {
      type: Object,
      default () {
        return {}
      }
    },
    requests: {
      type: Array,
      default () {
        return []
      }
    },
    date: {
      type: Date,
      default: null
    }
  },
  data: function () {
    return {
      loading: false,
      requestsLocal: JSON.parse(JSON.stringify(this.requests)),
      columns: [
        {
          name: 'key',
          label: 'Номер заявки',
          field: 'key',
          align: 'left',
          sortable: true
        },
        {
          name: 'state',
          label: 'Статус',
          field: 'stateName',
          align: 'left',
          sortable: true
        },
        {
          name: 'objectAlias',
          label: 'Объект',
          field: 'objectAlias',
          align: 'left',
          sortable: true
        },
        {
          name: 'autoAssigned',
          label: 'Назначена автоматически',
          field: 'autoAssigned',
          format: formatTrueFalse,
          align: 'left',
          sortable: true
        }
      ]
    }
  },
  computed: {
    requestsWithActiveWorks: function () {
      return this.requestsLocal.filter(request => ['BS5', 'BS6', 'BS7', 'BS14', 'BS15'].includes(request.state))
    }
  },
  methods: {
    onSaveDeleteBrigade: function (cancelActiveRequests = false) {
      this.loading = true
      axiosGet({
        url: '/service/delta/brigade/disband?id=' + this.brigade.id + '&workDate=' + this.date.getTime() + (this.brigade.workShift ? '&workShift=' + this.brigade.workShift.key : '') + (cancelActiveRequests ? '&cancelActiveRequests=true' : ''),
        onSuccess: () => {
          let employeesIds = []
          if (this.brigade.employees && this.brigade.employees.length) {
            employeesIds = this.brigade.employees.map((employee) => employee.id)
          }

          this.$emit('update', { brigades: { ids: [this.brigade.id], operation: 'delete' }, employees: { ids: employeesIds } })
          this.$q.notify({
            type: 'negative',
            message: 'Бригада "' + this.brigade.name + '" расформирована',
            progress: true,
            timeout: 8000
          })
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 8000
          })
        },
        msgTarget: this
      }).finally(() => {
        this.loading = false
      })
    },
    onCloseDeleteBrigade: function () {
      this.$emit('close')
    },
    onUpdate: function () {
      this.$emit('refresh')
    }
  }
}

